export function createGoogleMapsUrl(address: string, city: string): string {
  const formattedAddress = `${address} ${city}`.replace(/\s+/g, '+');
  return `https://www.google.com/maps/place/${formattedAddress}`;
}